import React from "react"
import { Box, Flex } from "@chakra-ui/react"
import { AppleIcon, GoogleIcon } from "./PassBuilderPlatformIcons"
import { PassBuilderPlatformTabLabel } from "./PassBuilderTypography"
import {
  PASS_BUILDER_PREVIEW_TAB_GAP,
  PASS_BUILDER_PREVIEW_TAB_HEIGHT,
  PASS_BUILDER_PREVIEW_TAB_PADDING,
  PASS_BUILDER_PREVIEW_TAB_SEGMENT_HEIGHT,
  PASS_BUILDER_PREVIEW_TAB_SEGMENT_WIDTH,
  PASS_BUILDER_PREVIEW_TAB_THUMB_HEIGHT,
  PASS_BUILDER_PREVIEW_TAB_THUMB_INSET,
  PASS_BUILDER_PREVIEW_TAB_ICON_LABEL_GAP,
  PASS_BUILDER_PREVIEW_TAB_THUMB_WIDTH,
  PASS_BUILDER_PREVIEW_TAB_WIDTH,
} from "./passBuilderTokens"

export type PassBuilderPlatform = "apple" | "google"

const PLATFORMS: PassBuilderPlatform[] = ["apple", "google"]

const SEGMENT_STEP = `calc(${PASS_BUILDER_PREVIEW_TAB_SEGMENT_WIDTH} + ${PASS_BUILDER_PREVIEW_TAB_GAP})`

type Props = {
  value: PassBuilderPlatform
  onChange: (platform: PassBuilderPlatform) => void
}

const PassBuilderPlatformSwitcher = ({ value, onChange }: Props) => {
  const activeIndex = value === "apple" ? 0 : 1

  return (
    <Box
      w={PASS_BUILDER_PREVIEW_TAB_WIDTH}
      h={PASS_BUILDER_PREVIEW_TAB_HEIGHT}
      flexShrink={0}
      p={PASS_BUILDER_PREVIEW_TAB_PADDING}
      bg="gray.50"
      borderRadius="lg"
      boxShadow="inset 0 0 0 1px var(--chakra-colors-gray-300)"
    >
      <Box
        position="relative"
        w="100%"
        h={PASS_BUILDER_PREVIEW_TAB_SEGMENT_HEIGHT}
      >
        <Box
          position="absolute"
          top={PASS_BUILDER_PREVIEW_TAB_THUMB_INSET}
          left={PASS_BUILDER_PREVIEW_TAB_THUMB_INSET}
          w={PASS_BUILDER_PREVIEW_TAB_THUMB_WIDTH}
          h={PASS_BUILDER_PREVIEW_TAB_THUMB_HEIGHT}
          bg="white"
          borderRadius="md"
          boxShadow="0 1px 4px rgba(0, 0, 0, 0.08)"
          transform={`translateX(${activeIndex === 0 ? "0" : SEGMENT_STEP})`}
          transition="transform 0.2s ease"
          pointerEvents="none"
        />
        <Flex gap={PASS_BUILDER_PREVIEW_TAB_GAP} position="relative" zIndex={1}>
          {PLATFORMS.map((id) => (
            <Flex
              key={id}
              as="button"
              type="button"
              w={PASS_BUILDER_PREVIEW_TAB_SEGMENT_WIDTH}
              h={PASS_BUILDER_PREVIEW_TAB_SEGMENT_HEIGHT}
              direction="column"
              justify="center"
              align="center"
              gap={PASS_BUILDER_PREVIEW_TAB_ICON_LABEL_GAP}
              flexShrink={0}
              bg="transparent"
              border="none"
              cursor="pointer"
              onClick={() => onChange(id)}
            >
              {id === "apple" ? (
                <AppleIcon variant="tab" />
              ) : (
                <GoogleIcon variant="tab" />
              )}
              <PassBuilderPlatformTabLabel lineHeight="1">
                {id === "apple" ? "Apple Wallet" : "Google Wallet"}
              </PassBuilderPlatformTabLabel>
            </Flex>
          ))}
        </Flex>
      </Box>
    </Box>
  )
}

export default PassBuilderPlatformSwitcher
